import type { PersonaNavConfig } from './types';

export const navAgency: PersonaNavConfig = {
  persona: 'agency',
  groups: [
    {
      key: 'top',
      items: [
        {
          key: 'dashboard',
          label: 'Tableau de bord',
          route: '/dashboard',
          icon: 'LayoutDashboard',
          matchStartsWith: '/dashboard',
        },
        {
          key: 'inbox',
          label: 'Boîte de tâches',
          route: '/inbox',
          icon: 'Inbox',
          badgeSource: 'inbox',
          permission: { module: 'workflow', feature: 'approval-read' },
        },
      ],
    },
    {
      key: 'interim',
      label: 'Intérim',
      tenantType: 'interim',
      items: [
        {
          key: 'missions',
          label: 'Missions',
          route: '/hr/missions',
          icon: 'Briefcase',
          matchStartsWith: '/hr/missions',
          permission: { module: 'hr', feature: 'mission-read' },
          moduleAvailable: 'interim',
        },
        {
          key: 'missions-ending',
          label: 'Missions qui expirent',
          route: '/hr/missions-ending',
          icon: 'TriangleAlert',
          badgeSource: 'missions-ending',
          permission: { module: 'hr', feature: 'mission-read' },
          moduleAvailable: 'interim',
        },
        {
          key: 'missions-margins',
          label: 'Marges missions',
          route: '/hr/missions/margins',
          icon: 'TrendingUp',
          matchStartsWith: '/hr/missions/margins',
          moduleAvailable: 'interim',
        },
        {
          key: 'interimaires',
          label: 'Intérimaires',
          route: '/hr/interimaires',
          icon: 'Users',
          matchStartsWith: '/hr/interimaires',
          permission: { module: 'hr', feature: 'interim-read' },
          moduleAvailable: 'interim',
        },
        {
          key: 'matching',
          label: 'Matching compétences',
          route: '/hr/interimaires/matching',
          icon: 'Target',
          matchStartsWith: '/hr/interimaires/matching',
          moduleAvailable: 'interim',
        },
        {
          key: 'feedbacks',
          label: 'Feedbacks missions',
          route: '/hr/mission-feedbacks',
          icon: 'Star',
          matchStartsWith: '/hr/mission-feedbacks',
          moduleAvailable: 'interim',
        },
        {
          key: 'clients',
          label: 'Clients',
          route: '/hr/clients',
          icon: 'Building2',
          matchStartsWith: '/hr/clients',
          permission: { module: 'hr', feature: 'client-read' },
          moduleAvailable: 'interim',
        },
        {
          key: 'timesheets-pending',
          label: 'Relevés à valider',
          route: '/hr/timesheets',
          icon: 'Clock',
          matchStartsWith: '/hr/timesheets',
          badgeSource: 'pending-timesheets',
          permission: { module: 'hr', feature: 'timesheet-read' },
          moduleAvailable: 'interim',
        },
      ],
    },
    {
      key: 'hr',
      label: 'Ressources humaines',
      items: [],
      subGroups: [
        {
          key: 'hr-acquisition',
          label: 'Acquisition',
          items: [
            {
              key: 'recruitment',
              label: 'Recrutement',
              route: '/hr/recruitment',
              icon: 'UserPlus',
              matchStartsWith: '/hr/recruitment',
              permission: { module: 'hr', feature: 'recruitment.view' },
              moduleAvailable: 'hr_core',
            },
            {
              key: 'recruitment-jobposts',
              label: 'Annonces',
              route: '/hr/recruitment/job-posts',
              icon: 'Megaphone',
              matchStartsWith: '/hr/recruitment/job-posts',
              permission: { module: 'hr', feature: 'recruitment.view' },
              moduleAvailable: 'hr_core',
            },
          ],
        },
        {
          key: 'hr-integration',
          label: 'Intégration',
          items: [
            {
              key: 'onboarding',
              label: 'Onboarding 90j',
              route: '/hr/onboarding',
              icon: 'UserPlus',
              matchStartsWith: '/hr/onboarding',
            },
            {
              key: 'contracts',
              label: 'Contrats',
              route: '/hr/contracts',
              icon: 'FileText',
              matchStartsWith: '/hr/contracts',
              permission: { module: 'hr_core', feature: 'contract-read' },
              moduleAvailable: 'hr_core',
            },
          ],
        },
        {
          key: 'hr-life',
          label: 'Vie au travail',
          items: [
            {
              key: 'employees',
              label: 'Employés',
              route: '/hr/employees',
              icon: 'User',
              matchStartsWith: '/hr/employees',
              permission: { module: 'hr_core', feature: 'employee-read' },
              moduleAvailable: 'hr_core',
            },
            {
              key: 'planning',
              label: 'Planning',
              route: '/hr/planning',
              icon: 'Calendar',
              matchStartsWith: '/hr/planning',
              permission: { module: 'hr', feature: 'planning-read' },
              moduleAvailable: 'time_mgmt',
            },
            {
              key: 'leaves',
              label: 'Congés',
              route: '/hr/leave-balances',
              icon: 'CalendarDays',
              permission: { module: 'hr', feature: 'leave-balance-read' },
              moduleAvailable: 'leave_mgmt',
            },
            {
              key: 'annual-review',
              label: 'Entretiens annuels',
              route: '/hr/annual-reviews',
              icon: 'ClipboardCheck',
              matchStartsWith: '/hr/annual-reviews',
            },
            {
              key: 'trainings',
              label: 'Plan de formation',
              route: '/hr/trainings',
              icon: 'GraduationCap',
              matchStartsWith: '/hr/trainings',
            },
            {
              key: 'skills',
              label: 'Matrice compétences',
              route: '/hr/skills',
              icon: 'Layers',
              matchStartsWith: '/hr/skills',
            },
            {
              key: 'analytics',
              label: 'Analytics People',
              route: '/hr/analytics',
              icon: 'Activity',
              matchStartsWith: '/hr/analytics',
            },
          ],
        },
        {
          key: 'hr-exit',
          label: 'Sortie & conformité',
          items: [
            {
              key: 'exit',
              label: 'Entretiens de sortie',
              route: '/hr/exit-interviews',
              icon: 'LogOut',
              matchStartsWith: '/hr/exit-interviews',
            },
            {
              key: 'carence',
              label: 'Période de carence',
              route: '/hr/compliance/carence',
              icon: 'Scale',
              matchStartsWith: '/hr/compliance/carence',
              moduleAvailable: 'interim',
            },
            {
              key: 'compliance',
              label: 'Compliance docs',
              route: '/hr/compliance/documents',
              icon: 'ShieldAlert',
              matchStartsWith: '/hr/compliance/documents',
            },
          ],
        },
      ],
    },
    {
      key: 'finance',
      label: 'Finance',
      items: [
        {
          key: 'payroll',
          label: 'Paie',
          route: '/hr/payroll',
          icon: 'DollarSign',
          matchStartsWith: '/hr/payroll',
          permission: { module: 'payroll', feature: 'payroll-read' },
          moduleAvailable: 'payroll',
        },
        {
          key: 'invoices',
          label: 'Factures clients',
          route: '/billing/invoices',
          icon: 'FileText',
          permission: { module: 'billing', feature: 'invoice-read' },
          moduleAvailable: 'billing',
        },
        {
          key: 'payments',
          label: 'Paiements',
          route: '/payments',
          icon: 'Wallet',
          permission: { module: 'payments', feature: 'request-read' },
          moduleAvailable: 'payments',
        },
      ],
    },
    {
      key: 'admin-ops',
      label: 'Administratif',
      items: [
        {
          key: 'ged',
          label: 'Documents (GED)',
          route: '/ged/documents',
          icon: 'Folder',
          matchStartsWith: '/ged',
          permission: { module: 'ged', feature: 'document-read' },
          moduleAvailable: 'ged',
        },
        {
          key: 'processes',
          label: 'Process models',
          route: '/workflows/configurations',
          icon: 'Workflow',
          matchStartsWith: '/workflows/configurations',
          permission: { module: 'workflow', feature: 'config-read' },
          moduleAvailable: 'workflow',
        },
        {
          key: 'instances',
          label: 'Instances',
          route: '/workflows/instances',
          icon: 'Activity',
          matchStartsWith: '/workflows/instances',
          permission: { module: 'workflow', feature: 'instance-read' },
          moduleAvailable: 'workflow',
        },
      ],
    },
    {
      key: 'admin',
      label: 'Administration',
      adminOnly: true,
      items: [
        {
          key: 'users',
          label: 'Utilisateurs',
          route: '/admin/users',
          icon: 'UserCog',
          matchStartsWith: '/admin/users',
          permission: { module: 'admin', feature: 'user.view' },
        },
        {
          key: 'tenants',
          label: 'Tenants',
          route: '/admin/tenants',
          icon: 'Building',
          matchStartsWith: '/admin/tenants',
          permission: { module: 'admin', feature: 'tenant.view' },
        },
        {
          key: 'profiles',
          label: 'Profils',
          route: '/admin/profiles',
          icon: 'ShieldCheck',
          matchStartsWith: '/admin/profiles',
          permission: { module: 'admin', feature: 'profile.view' },
        },
        {
          key: 'permissions',
          label: 'Permissions',
          route: '/admin/permissions',
          icon: 'Key',
          permission: { module: 'admin', feature: 'permission.view' },
        },
        {
          key: 'modules',
          label: 'Modules',
          route: '/admin/modules',
          icon: 'Server',
          permission: { module: 'admin', feature: 'module.view' },
        },
        {
          key: 'licences',
          label: 'Licences',
          route: '/admin/licences',
          icon: 'CreditCard',
          permission: { module: 'admin', feature: 'licence.view' },
        },
        {
          key: 'admin-workflows',
          label: 'Workflows & overrides',
          route: '/admin/workflows',
          icon: 'GitBranch',
          matchStartsWith: '/admin/workflows',
          permission: { module: 'admin', feature: 'workflow.view' },
        },
        {
          key: 'admin-imports',
          label: 'Templates d\'import',
          route: '/admin/imports',
          icon: 'Upload',
          matchStartsWith: '/admin/imports',
          permission: { module: 'admin', feature: 'workflow.view' },
        },
      ],
    },
  ],
};
